import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import styles from './GrapeGame.module.css';
import SettingsModal from '../components/modals/SettingsModal';
import Header from '../components/Header';
import GrapeBoard from './grape/GrapeBoard';

const GrapeGame = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [showGameListModal, setShowGameListModal] = useState(false);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showRestartModal, setShowRestartModal] = useState(false);
  const [showRestartConfirmModal, setShowRestartConfirmModal] = useState(false);
  const boardRef = useRef(null);

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setShowShareModal(true);
    } catch (err) {
      alert('링크 복사에 실패했어요. 주소창의 URL을 직접 복사해주세요!');
      console.error('클립보드 복사 실패:', err);
    }
  };

  const handleRestartClick = () => {
    if (boardRef.current?.isGameStarted) {
      setShowRestartModal(true);
    } else {
      boardRef.current?.handleRestart();
    }
  };

  return (
    <div className={styles.container}>
      <Header 
        title={t('games.grape.title')}
        onGameList={() => setShowGameListModal(true)}
        onRules={() => setShowRulesModal(true)}
        onSettings={() => setShowSettingsModal(true)}
        onRestart={handleRestartClick}
      />

      <div className={styles.gameContainer}>
        <GrapeBoard ref={boardRef} />
      </div>

      {showGameListModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.gameList.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowGameListModal(false)}>
                {t('modals.confirm.cancel')}
              </button>
              <button onClick={() => navigate('/')}>
                {t('modals.confirm.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSettingsModal && (
        <SettingsModal
          onClose={() => setShowSettingsModal(false)}
          onContact={() => {
            setShowSettingsModal(false);
            setShowContactModal(true);
          }}
          onShare={handleShare}
        />
      )}

      {showContactModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.contact.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowContactModal(false)}>
                {t('modals.contact.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showShareModal && (
        <div className="modal-overlay">
          <div className="modal share-modal">
            <p>{t('modals.share.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowShareModal(false)}>
                {t('modals.share.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showRulesModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>{t('games.grape.rules.title')}</h2>
            <p style={{ whiteSpace: 'pre-line' }}>{t('games.grape.rules.description')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowRulesModal(false)}>
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showRestartModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.confirm.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowRestartModal(false)}>
                {t('modals.confirm.cancel')}
              </button>
              <button onClick={() => {
                boardRef.current?.handleRestart();
                setShowRestartModal(false);
              }}>
                {t('modals.confirm.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GrapeGame; 